import React from "react";

export default function ProgressBar({ progress }) {
  return (
    <div className="progressbar">
      <div className="progressbar-container">
        <div
          className="progressbar-container-body"
          style={{ width: `${progress}%` }}
        >
          {Math.floor(progress)}%
        </div>
      </div>
    </div>
  );
}
